<div class="goBack back-btn" (click)="goBack()"></div>
<div class="collection-container vertical-as" [@zoomStagger]>
  <div class="hero" *ngIf="resource">
    <app-content-detail
      class="collection-content-detail zoom-item"
      [resource]="resource"
      [maxLines]="3"
    ></app-content-detail>
  </div>
  <app-grid
    (keydown)="onArrowDown($event)"
    [data]="resources"
    [aspectRatio]="'2x3'"
    [setMargin]="false"
    [showHeader]="header.length > 0"
    [header]="header"
    [canUpdateCurrentResource]="true"
    class="data-container"
    [shouldReuse]="true"
  ></app-grid>
</div>
